module.exports = __webpack_public_path__ + "img/instruction-android-01.1c3b6f06.png";